import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWikidata = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 15,
			height: 15,
			rx: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.70214 11.4466H2.11782V1.36786H1.70214V11.4466ZM2.56124 11.4466H3.83594V1.36786H2.56124V11.4466ZM4.2517 1.36786V11.4462H5.5264V1.36786H4.2517Z",
			fill: "#990000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9585 11.4473H12.3743V1.36786H11.9585V11.4473ZM12.8177 1.36786V11.4473H13.2334V1.36786H12.8177ZM5.95591 11.4473H6.37159V1.36786H5.95591V11.4473ZM6.8151 1.36786V11.4469H7.23086V1.36786H6.8151Z",
			fill: "#339966"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.6602 11.4473H8.93507V1.36786H7.6602V11.4473ZM9.35066 11.4473H9.794V1.36786H9.35066V11.4473ZM10.2098 1.36786V11.4469H11.4845V1.36786H10.2098Z",
			fill: "#006699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6 12.5567L13.2559 14.6469H12.8603L12.7386 14.2339H12.0774L11.9674 14.6469H11.5771L12.1727 12.5567H12.6ZM12.6297 13.8689L12.3916 13.0565L12.1748 13.8689H12.6297ZM11.7707 12.5567V12.9398H11.2354V14.6469H10.8672V12.9398H10.3319V12.5567H11.7707ZM9.86646 12.5567L10.5223 14.6469H10.1267L10.005 14.2339H9.34386L9.23384 14.6469H8.84348L9.43907 12.5567H9.86646ZM9.89608 13.8689L9.65805 13.0565L9.44118 13.8689H9.89608ZM7.37936 12.5567H8.03102C8.28279 12.5567 8.48168 12.6545 8.62767 12.85C8.77436 13.0445 8.84771 13.2963 8.84771 13.6056C8.84771 13.9297 8.7733 14.1846 8.62449 14.3701C8.47639 14.5546 8.26481 14.6469 7.98976 14.6469H7.37936V12.5567ZM7.7475 12.9398V14.2639H7.98764C8.1435 14.2639 8.26269 14.2035 8.34521 14.0828C8.42772 13.9611 8.46898 13.8011 8.46898 13.6026C8.46898 13.3971 8.42702 13.2355 8.34309 13.1178C8.25987 12.9991 8.13998 12.9398 7.98341 12.9398H7.7475ZM7.03871 12.5567V14.6469H6.67057V12.5567H7.03871ZM6.34157 12.5567L5.86023 13.5382L6.51294 14.6469H6.0517L5.46669 13.6669V14.6469H5.09854V12.5567H5.46669V13.4978L5.93639 12.5567H6.34157ZM4.7579 12.5567V14.6469H4.38976V12.5567H4.7579ZM2.94468 13.3108L2.48767 14.6738H2.32899L1.67944 12.5567H2.0698L2.41785 13.7118L2.79763 12.5567H3.09384L3.47363 13.7118L3.81956 12.5567H4.20992L3.56249 14.6738H3.4038L2.94468 13.3108Z",
			fill: "black"
		})
	]
});
export default SvgWikidata;
